function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
        callback();
    } else {
        setTimeout(function () {
            waitForSwiper(callback);
        }, 50);
    }
}

waitForSwiper(function () {
    $(document).ready(function () {

        const swiperMap = new WeakMap();

        $('.testimonials-slider').each(function (index, element) {
            const swiper = new Swiper(element, {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 10,
                speed: 400,

                allowTouchMove: true,
                simulateTouch: true,
                grabCursor: true,

                navigation: {
                    nextEl: $(element).closest('.custom_testimonials').find('.custom-next_slr')[0],
                    prevEl: $(element).closest('.custom_testimonials').find('.custom-prev_slr')[0],
                },

                pagination: {
                    el: $(element).closest('.custom_testimonials').find('.swiper-pagination')[0],
                    clickable: true,
                },

                breakpoints: {
                    0:    { slidesPerView: 1.2 },
                    768:  { slidesPerView: 2 },
                    1024: { slidesPerView: 3 }
                }
            });

            swiperMap.set(element, swiper);
        });

        $('.custom_testimonials').on('click', '.read-more-btn', function () {
            const $wrap = $(this).closest('.testimonial-text');
            const testimonialCard = $(this).closest('.testimonial-card');
            const sliderEl = $(this).closest('.testimonials-slider')[0];
            const swiper = swiperMap.get(sliderEl);

            $wrap.find('.testimonial-text-short').hide();
            $wrap.find('.testimonial-text-full').show();
            $wrap.find('.read-more-btn').hide();
            $wrap.find('.read-less-btn').show();
            $(testimonialCard).css('height', '100%');

            if (swiper) {
                swiper.updateAutoHeight();
                swiper.update();
            }
        });

        $('.custom_testimonials').on('click', '.read-less-btn', function () {
            const $wrap = $(this).closest('.testimonial-text');
            const testimonialCard = $(this).closest('.testimonial-card');
            const sliderEl = $(this).closest('.testimonials-slider')[0];
            const swiper = swiperMap.get(sliderEl);

            $wrap.find('.testimonial-text-short').show();
            $wrap.find('.testimonial-text-full').hide();
            $wrap.find('.read-more-btn').show();
            $wrap.find('.read-less-btn').hide();
            $(testimonialCard).css('height', '280px');

            if (swiper) {
                swiper.updateAutoHeight();
                swiper.update();
            }
        });

        // Announcement bar
        new Swiper('.custom_announcement_wrapper', {
            slidesPerView: 1,
            loop: true,
            initialSlide: 0,
            speed: 400,

            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },

            allowTouchMove: true,
            simulateTouch: true,
            grabCursor: true,
            touchRatio: 1,
            touchAngle: 45,
            threshold: 5,
        });

    });
});

// function initGallerySwiper(element) {
//     if ($(element).hasClass('swiper-initialized')) return;

//     new Swiper(element, {
//         slidesPerView: 5,
//         slidesPerGroup: 1,
//         mousewheel: { enabled: true },
//         keyboard: { enabled: true },
//         freeMode: true,
//         watchSlidesProgress: true,
//         updateOnWindowResize: true,
//         navigation: {
//             nextEl: element.querySelector('[data-swiper-next]'),
//             prevEl: element.querySelector('[data-swiper-prev]'),
//         }
//     });
// }

// const observer = new MutationObserver(function (mutations) {
//     mutations.forEach(function (mutation) {
//         mutation.addedNodes.forEach(function (node) {
//             if (node.nodeType !== 1) return;

//             $(node)
//                 .find('.product-gallery__navigation')
//                 .addBack('.product-gallery__navigation')
//                 .each(function () {
//                     initGallerySwiper(this);
//                 });
//         });
//     });
// });

// observer.observe(document.body, { childList: true, subtree: true });


document.addEventListener("DOMContentLoaded", () => {
  const content = document.querySelector(".read-more-content-custom-ds");
  const button = document.querySelector(".read-more-btn-des-col");

  if (!content || !button) return;

  button.addEventListener("click", () => {
    const expanded = content.classList.toggle("expanded");

    button.textContent = expanded
      ? "Read Less"
      : "Read More";

    button.setAttribute(
      "aria-expanded",
      expanded
    );
  });
});